import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Services
import { getTaskById } from '../../../services/tasksQueue.service';

// Redux
import { useAppDispatch, useAppSelector } from '../../../redux/hook';
import { fetchAllSettings } from '../../../redux/slices/settingsSlice';
import { fetchTasksQueueAssignableUsers } from '../../../redux/slices/tasksQueueSlice';

// Component
import { Spinner } from '../../common/Spinner';
import TasksQueueDetails from './components/tasksQueueDetails';

const TaskDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [taskData, setTaskData] = useState(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const dispatch = useAppDispatch();
  const settingStates = useAppSelector((state) => state.settings);

  useEffect(() => {
    const fetchTaskData = async () => {
      if (id) {
        try {
          const data: any = await getTaskById(id);
          setTaskData(data.data.results[0]);
          setErrorMessage(null); // Clear any previous error messages
        } catch (error) {
          setErrorMessage('Error fetching task data, please try again later');
        }
      } else {
        setErrorMessage('Task ID is undefined.');
      }
    };

    fetchTaskData();
  }, [id]);

  useEffect(() => {
    dispatch(fetchAllSettings());
    dispatch(fetchTasksQueueAssignableUsers());
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleWatchersUpdate = () => {};

  return (
    <>
      {errorMessage ? (
        <p>{errorMessage}</p>
      ) : taskData ? (
        <TasksQueueDetails selectedRowData={taskData} settingStates={settingStates} onWatchersUpdate={handleWatchersUpdate} />
      ) : (
        <Spinner loading />
      )}
    </>
  );
};

export default TaskDetail;
